import React, { lazy, Suspense, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
const AddWarehousesModal = lazy(() =>
  import("src/features/Modal").then((modal) => ({
    default: modal.AddWarehouses,
  }))
);

export default function AddWarehousesButton() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Button
        style={{ marginBottom: 15 }}
        icon={<PlusOutlined />}
        type="primary"
        onClick={() => setOpen(true)}
      >
        Добавить магазин/склад/участок
      </Button>
      {isOpen ? (
        <Suspense fallback={<div></div>}>
          <AddWarehousesModal isOpen={isOpen} setOpen={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}
